import React, { FC, PropsWithChildren, ReactNode } from 'react'

import { WithDataName } from 'common/types'
import { PrimaryButton } from 'components/designSystem/Button/PrimaryButton'
import { Color } from 'components/designSystem/Button/types.common'

import { selectGenderPath } from '../Onboarding/paths'

export const RegisterButton: FC<
  { color?: Color; icon?: ReactNode } & PropsWithChildren & WithDataName
> = ({ icon, color, children, ...rest }) => {
  return (
    <PrimaryButton
      icon={icon}
      size="M"
      color={color}
      to={selectGenderPath}
      data-name={rest['data-name']}
    >
      {children}
    </PrimaryButton>
  )
}
